(function () {
    'use strict';

    angular
        .module('ib-cki-modal-module')
        .controller('ibLoadingPlaneController', ibLoadingPlaneController);

    ibLoadingPlaneController.$inject = ['$uibModal', '$location', '$rootScope', 'ComponentUtils'];
    function ibLoadingPlaneController($uibModal, $location, $rootScope, ComponentUtils) {

    }
})();